import { render, staticRenderFns } from "./Members2.vue?vue&type=template&id=67db8b54&scoped=true"
import script from "./Members2.vue?vue&type=script&lang=js"
export * from "./Members2.vue?vue&type=script&lang=js"
import style0 from "./Members2.vue?vue&type=style&index=0&id=67db8b54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67db8b54",
  null
  
)

export default component.exports